declare module 'pixi-particles' {
  interface Emitter {
    /**
     * Whether emitter is playing
     */
    playing: boolean;

    /**
     * Wheather emitter is destroyed
     */
    destroyed: boolean;
  }
}

import { Emitter } from 'pixi-particles';

Emitter.prototype.playing = false;
Emitter.prototype.destroyed = false;

const playOnceAndDestroy = Emitter.prototype.playOnceAndDestroy;
Emitter.prototype.playOnceAndDestroy = function (callback?: () => void): void {
  this.parent.ecBeforeDestroyCallbacks.push(() => {
    this.destroy();
  });
  this.playing = true;
  playOnceAndDestroy.call(this, () => {
    this.playing = false;
    if (callback) {
      callback();
    }
  });
};

const destroy = Emitter.prototype.destroy;
Emitter.prototype.destroy = function (): void {
  if (!this.destroyed) {
    this.playing = false;
    this.destroyed = true;
    destroy.call(this);
  }
};
